exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".will-delete-swatch[data-v-3127e7cf] {\n  overflow: visible;\n}\n.smooth-dnd-ghost[data-v-3127e7cf] {\n  width: 4rem !important;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.4);\n}", ""]);

// exports
